import { PostContentBlockMap } from 'components/Blocks/index.types';
import HeroBlock from 'components/Blocks/HeroBlock/HeroBlock';
import { CtaInstagramFeedSectionFullScreen } from 'components/Blocks/CtaInstagramFeedSection/CtaInstagramFeedSectionFullScreen';
import { Paragraph } from 'components/Blocks/Paragraph/Paragraph';
import { List } from 'components/Blocks/List/List';
import { ListItem } from 'components/Blocks/List/ListItem';
import { HowTo } from 'components/Blocks/HowTo/HowTo';
import { FAQList } from 'components/Blocks/FAQList/FAQList';
import PageSection from 'components/Blocks/PageSection/PageSection';
import { Image } from 'components/Blocks/Image/Image';
import { TwoColumnsTextSection } from 'components/Blocks/TwoColumnsTextSection/TwoColumnsTextSection';
import { MultiPhotoSlider } from 'components/Blocks/MultiPhotoSlider/MultiPhotoSlider';
import { MultiPhotoSliderWithText } from './MultiPhotoSlider/MultiPhotoSliderWithText';
import { QuoteSlider } from 'components/Blocks/QuoteSlider/QuoteSlider';
import { RunningText } from 'components/Blocks/RunningText/RunningText';
import IframeSection from 'components/Blocks/IframeSection/IframeSection';
import { CtaButtonGroup } from 'components/Blocks/CtaButtonGroup/CtaButtonGroup';
import { SectionTitle } from './SectionTitle/SectionTitle';
import PageLifeSection from 'components/Blocks/PageLifeSection/PageLifeSection';
import BenefitsSection from 'components/Blocks/BenefitSection/BenefitSection';
import PageImageTextSection from './PageImageTextSection/PageImageTextSection';

const defaultBlockMap: PostContentBlockMap = {
    /**
     * Reused specific blocks
     */
    'bumble-success-stories/cta-instagram-feed-section': CtaInstagramFeedSectionFullScreen,
    'bumble-success-stories/hero-block': HeroBlock,
    'team-bumble-ui-blocks/hero-image': HeroBlock,
    'bumble-success-stories/iframe-section': IframeSection,
    'team-bumble-ui-blocks/benefits-list': BenefitsSection,
    'team-bumble-ui-blocks/page-life-section': PageLifeSection,
    'team-bumble-ui-blocks/page-image-text-section': PageImageTextSection,
    /**
     * Project specific blocks
     */
    'bumble-honey-ambassadors/cta-button-group': CtaButtonGroup,
    'bumble-honey-ambassadors/hero-block-vimeo-video': HeroBlock,
    'bumble-honey-ambassadors/multi-photo-slider': MultiPhotoSlider,
    'bumble-honey-ambassadors/multi-photo-slider-with-text': MultiPhotoSliderWithText,
    'bumble-honey-ambassadors/page-section': PageSection,
    'bumble-honey-ambassadors/running-text': RunningText,
    'bumble-honey-ambassadors/quote-slider': QuoteSlider,
    'bumble-honey-ambassadors/two-columns-text-section': TwoColumnsTextSection,
    /**
     * General WP Blocks
     */
    'yoast/how-to-block': HowTo,
    'yoast/faq-block': FAQList,
    'core/image': Image,
    'core/heading': SectionTitle,
    'core/paragraph': Paragraph,
    'core/list': List,
    'core/list-item': ListItem,
};

export default defaultBlockMap;
